/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const errorMessage = (error: any): string => {
  console.log('Error Received: ', error); // for debugging purposes
  const errorMessage =
    'An unexpected error occurred. Please contact your administrator.';
  return errorMessage;
};
